import { render, staticRenderFns } from "./DownloadADocument.vue?vue&type=template&id=93fe9de6&scoped=true"
import script from "./DownloadADocument.vue?vue&type=script&lang=js"
export * from "./DownloadADocument.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93fe9de6",
  null
  
)

export default component.exports